import { SerieEffects } from "./serie"
import { ChapterEffects } from "./chapter"
import { VolumeEffects } from "./volume"
import { UserChapterStatusEffects } from "./user-chapter-status"

export const EffectsList = [ SerieEffects, ChapterEffects, VolumeEffects, UserChapterStatusEffects ]